/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React from 'react';
import { Scrollbar } from "smooth-scrollbar/interfaces";

let scrollRef: React.LegacyRef<Scrollbar> | undefined = undefined;

export function setScroll(ref: React.LegacyRef<Scrollbar> | undefined | any): void {
  if (ref) {
    scrollRef = ref
  }
}

export function getScroll(): Scrollbar | undefined {
  if (scrollRef) {
    return (scrollRef as any).scrollbar as Scrollbar
  }
  return undefined;
}